import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/sobre-gs',
    name: 'sobre-gs',
    component: () => import(/* webpackChunkName: "sobre-gs" */ '../views/SobreGsView.vue')
  },
  {
    path: '/equipo',
    name: 'equipo',
    component: () => import(/* webpackChunkName: "equipo" */ '../views/EquipoView.vue')
  },
  {
    path: '/nuestro-contenido',
    name: 'nuestro-contenido',
    component: () => import(/* webpackChunkName: "nuestro-contenido" */ '../views/NuestroContenidoView.vue')
  },
  {
    path: '/gs-tech-lab',
    name: 'gs-tech-lab',
    component: () => import(/* webpackChunkName: "gs-tech-lab" */ '../views/GsTechLabView.vue')
  },
  {
    path: '/division-sur',
    name: 'division-sur',
    component: () => import(/* webpackChunkName: "division-sur" */ '../views/DivisionSurView.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import(/* webpackChunkName: "contacto" */ '../views/ContactView.vue')
  },
  {
    path: '/casos-destacados',
    name: 'casos-destacados',
    component: () => import(/* webpackChunkName: "casos-destacados" */ '../pages/CasosDestacadosPage.vue')
  },
  {
    path: '/prensa',
    name: 'prensa',
    component: () => import(/* webpackChunkName: "prensa" */ '../pages/PrensaListPage.vue')
  },
  {
    path: '/prensa/:slug',
    name: 'prensa-articulo',
    component: () => import(/* webpackChunkName: "prensa-articulo" */ '../pages/PrensaPage.vue'),
    beforeEnter(to) {
      const slug = String(to.params.slug ?? '').trim()
      const exists = store.getters.prensaByLink(slug)
      if (exists) return true
      return { name: 'prensa' }
    },
  },
  {
    path: '/:slug',
    name: 'caso-destacado',
    component: () => import(/* webpackChunkName: "caso-destacado" */ '../pages/CasoPage.vue'),
    beforeEnter(to) {
      const slug = String(to.params.slug ?? '').trim()
      const exists = store.getters.casoByLink(slug)
      if (exists) return true
      return { name: 'home' }
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
})

export default router